import React from 'react';
import MainLayout from 'components/layouts/MainLayout';
import Banner from 'components/artectum/slides/banner-artectum';
import SearchForm from 'components/artectum/common/search-form-arctectum';
import FeaturedItem from 'components/artectum/slides/featured-product-artectum';
import BlogSlider from 'components/artectum/slides/featured-projects-artectum';
import Category from 'components/artectum/common/category-artectum';
import { Helmet } from 'react-helmet';

const MainHome = () => {
    return (
        <MainLayout>
            <Helmet>
                <title>Acabados para Construcción en Lima | Artectum</title>
                <meta name="description" content="Descubre acabados en baldosas, terrazos, mosaicos y celosías con máxima durabilidad y diseño exclusivo. Cotiza tu proyecto hoy." />
            </Helmet>
            <Banner />
            <FeaturedItem />
            <SearchForm />
            <BlogSlider sectionClass="pt-130" />
            <Category />
        </MainLayout>
    );
}

export default MainHome;